import React, { Component } from 'react';
import { connect } from 'react-redux';
import TicketCarouselItem from "../ticketcarouselitem/ticketcarouselitem.component";
import Slider from "react-slick/lib";

class CarouselTickets extends Component {


    getContent = () => {
        if (this.props.cards) {
            if(this.props.cards.length > 4)  {
                return this.props.cards.map((card, i) => {
                    return (
                        <div key={i}>
                            <div className="row no-gutters">
                                <TicketCarouselItem card={card}/>
                            </div>
                        </div>
                    )
                })
            } else {
                return this.props.cards.map((card, i) => {
                    return (
                        <div className="col-lg-3">
                            <TicketCarouselItem card={card}/>
                        </div>
                    )
                })
            }
        }
    }

    getConditionalComponents = (settings) => {
        if(this.props.cards && this.props.cards.length > 4) {
            return (
                <Slider {...settings}>
                    {
                        this.getContent()
                    }
                </Slider>
            )
        } else {
            return (
                 this.getContent()
            )
        }
    }

    render() {
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: this.props.defaultSlidesToShow,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        };

        return (
            <div className={this.props.cards && this.props.cards.length > 4 ? "carousel": "row carousel"}>
                {
                    this.getConditionalComponents(settings)
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(CarouselTickets);





// WEBPACK FOOTER //
// ./src/SHARED/components/carouseltickets/carouseltickets.component.js